var Tipo_condominioComponent = /** @class */ (function () {
    function Tipo_condominioComponent() {
        this.rows = [];
        this.condominio = { "A": false, "B": false };
        if (!JSON.parse(localStorage.getItem("tipo_condominio"))) {
            localStorage.setItem("tipo_condominio", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("tipo_condominio"));
            this.condominio = {
                "A": this.rows[0] ? this.rows[0].condominio["A"] : false,
                "B": this.rows[0] ? this.rows[0].condominio["B"] : false,
            };
        }
    }
    Tipo_condominioComponent.prototype.ngOnInit = function () {
        this.n_form = localStorage.getItem("form");
        console.log("Formulario", this.n_form);
    };
    Tipo_condominioComponent.prototype.add_tipo_condominio = function () {
        localStorage.setItem("tipo_condominio", JSON.stringify([]));
        this.actualRow = localStorage.getItem("tipo_condominio");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            condominio: this.condominio
        });
        localStorage.setItem("tipo_condominio", JSON.stringify(this.rows));
        console.log(JSON.parse(localStorage.getItem("tipo_condominio")));
    };
    Tipo_condominioComponent.prototype.delete_tipo_condominio = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("tipo_condominio", JSON.stringify(this.rows));
            }
        }
    };
    return Tipo_condominioComponent;
}());
export { Tipo_condominioComponent };
